import { useNavigate } from 'react-router';
import { ContinueButton } from '../../../../components/ContinueButton/ContinueButton';
import { Image } from '../../../../components/Image/Image';
import styles from './EffectSection.module.scss';
import { ampScreenCompleted } from '../../../../utils/AmplitudeEvents';
import { useEffect } from 'react';
export const EffectSection = ({ content, nextSlug })=>{
  useEffect(() => {
    const initAmplitudeWithReplay = async () => {
      const { sessionReplayPlugin } = await import('@amplitude/plugin-session-replay-browser');
      sessionReplayPlugin({
        sampleRate: 1,
      });
    };

    initAmplitudeWithReplay();
  }, []);
  const navigate = useNavigate();
  const { slug, title, subtitles, button, info, chart } = content;
  return (
    <>
    <div className={styles.wrapper}>
      {title && <div className={styles.title}>{title}</div>}
      {subtitles && <div className={styles.subtitles}>
          <div className={styles.before}>{subtitles.before}</div>
          <div className={styles.after}>{subtitles.after}</div>
        </div>
      }
      {chart && <Image className={styles.image} src={chart}/>}
      {info && <div className={styles.info}>
        {
          info.map((item, index) => {
            return (
              <div key={index} className={styles.item}>
                {item?.icon && <Image src={item.icon} className={styles.icon}/>}
                <div className={styles.itemText} dangerouslySetInnerHTML={{ __html:item.text }} />
              </div>
            )
          })
        }
        </div>}
    </div>
    <ContinueButton
        onClick={() => {
          ampScreenCompleted(slug,title || null)
          setTimeout(() => {
            navigate(nextSlug);
          }, 500);
        }}
      >
        {button || null}
      </ContinueButton>
    </>
  )
}